module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1284ac98b48c05d0b81c1eb23532594a.png";